import React, { useContext, useEffect, useState } from 'react'
import { Flex, Flexed } from '../../utilities/Shared'
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from 'axios'
import { toast } from 'react-toastify'
import { sortit, sortnum } from '../../utilities/Sort'
import UserContext from '../../Context/UserContext'

const JobSearch = ({term,csrreps,salesreps}) => {

const [newjobs, setNewjobs] = useState([])
const [oldjobs, setOldjobs] = useState([])
const [newerjobs, setNewerjobs] = useState([])
const [order, setOrder] = useState("ASC")
const {userInfo,logout } = useContext(UserContext)
const nav = useNavigate()
useEffect(() => {
    const getjobsbyname = async() => {
        const config = {
            headers: {
              'Content-Type': 'application/json',
              'Access-Control-Allow-Origin':'*' 
            }};    
          const tr = {
            searchitem:term
      }
     await axios.post(`https://highgroundsoftware.com/dash/dashboard/php/getjobsbyname.php`,tr,config)
     .then(res => {setNewerjobs(res.data)})
     .catch(err => toast.error(err))   
    }
    getjobsbyname()
},[])




   
console.log(newerjobs)

  return (
    <>
  {newerjobs.length >0 &&  <div style={{border:"1px solid #303030",margin:"30px 0px"}}>
    <Flexed ><Flex  bgColor="#0E425A" color="white" fontSize="calc(1.5rem + .4vw)">JOB RESULTS &nbsp; &nbsp;{newerjobs.length}</Flex></Flexed>
    <Flexed bgColor="#8398AB" padding="3px 0px" fontWeight="bold" color="white" className="hand">
        <Flex fontSize="var(--headerMedium)" flex=".5" onClick={() => sortnum('job',order,newerjobs,setNewerjobs,setOrder)}>Job#</Flex>
        <Flex fontSize="var(--headerMedium)" flex=".7" onClick={() => sortnum('quote',order,newerjobs,setNewerjobs,setOrder)}>Quote#</Flex>
        <Flex fontSize="var(--headerMedium)" flex="2.5" onClick={() => sortit('customer',order,newerjobs,setNewerjobs,setOrder)}>Customer</Flex>
        <Flex fontSize="var(--headerMedium)" onClick={() => sortnum('origquantity',order,newerjobs,setNewerjobs,setOrder)}>Quantity</Flex>
        <Flex fontSize="var(--headerMedium)" flex="2.5" onClick={() => sortit('jobname',order,newerjobs,setNewerjobs,setOrder)}>Job Name</Flex>
        <Flex fontSize="var(--headerMedium)" onClick={() => sortit('custpo',order,newerjobs,setNewerjobs,setOrder)}>PO#</Flex>
        <Flex fontSize="var(--headerMedium)" onClick={() => sortit('salesrep',order,newerjobs,setNewerjobs,setOrder)}>Salesrep</Flex>
        <Flex fontSize="var(--headerMedium)" onClick={() => sortit('csr',order,newerjobs,setNewerjobs,setOrder)}>CSR</Flex>
    </Flexed>
   
    {newerjobs?.map(job => {
     return <Flexed className="normalrow" >
    <Flex  flex=".5"style={{fontSize:"var(--headerMedium)"}} > <Link style={{fontSize:"var(--headerMedium)"}} to={`/jobticket/${job.job}`}>{job.job} </Link></Flex>
     <Flex  flex=".7" >{userInfo.auth?.includes('600')|| userInfo.auth?.includes('106') ? <a style={{fontSize:"var(--headerMedium)"}}  href={` https://highgroundsoftware.com/dash/dashboard/?des=15002&q=${job.quote}`} >{job.quote}</a> : <>{job.quote}</>}</Flex>
     <Flex  flex="2.5"  >{job.customer}</Flex>
     <Flex > <a style={{fontSize:"var(--headerMedium)"}}  href={`/jobticket/${job.job}`} >{job.origquantity}</a></Flex>
     <Flex fontSize="var(--headerMedium)" flex="2.5"> <a style={{fontSize:"var(--headerMedium)"}}  href={`/jobticket/${job.job}`} >{job.jobname}</a></Flex>
     
     <Flex fontSize="var(--headerMedium)"> <a style={{fontSize:"var(--headerMedium)"}}  href={`/jobticket/${job.job}`} >{job.custpo}</a></Flex>
     <Flex > <a style={{fontSize:"var(--headerMedium)"}}  href={`/jobticket/${job.job}`} >{salesreps?.filter(rep => rep.empId === job.salesrep).map(rep =>{return rep.firstName+" "+rep.lastName.substr(0,1)})}</a></Flex>
     <Flex > <a style={{fontSize:"var(--headerMedium)"}}  href={`/jobticket/${job.job}`} >{csrreps?.filter(rep => rep.empId === job.csr).map(rep =>{return rep.firstName+" "+rep.lastName.substr(0,1)})}</a></Flex>
    
    </Flexed>
    })
       
    }
    </div>}
    </>
  )
}

export default JobSearch